/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import ProjectListHeader from "../ProjectListHeader/ProjectListHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import ProjectListFilterPopup from "../Popup/ProjectListFilterPopup";
import { assetImages } from "constants";
import DeleteProjectWarningModal from "../Modal/DeleteProjectWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import ProjectManagementCommonHeader from "components/ProjectManagementComponents/Common/Header/ProjectManagementCommonHeader";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddCompanyModal from "components/Common/Modal/AddCompanyModal";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
import ProjectDisablePopup from "../Popup/ProjectDisablePopup";
// import AddProjectPopup from "../Popup/AddProjectPopup";

const ProjectListBody = () => {
  const params = useParams();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [projectList, setProjectList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  // ✅ only one loading control — when to show skeleton
  const [showSkeleton, setShowSkeleton] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  // delete project offcanvas
  const [showDeleteOffcanvas, setShowDeleteOffcanvas] = useState(false);

  //stats counts
  const [followingProjectCount, setfollowingProjectCount] = useState(0);
  const [totalTaskCount, settotalTaskCount] = useState(0);
  const [totalLogsCount, settotalLogsCount] = useState(0);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // ✅ CHANGED: null = popup hasn't decided yet (skip API call)
  // []    = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // global search
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get project list
  const getProjectList = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_PROJECTS}?token=${token}&userrolestring=${userInfo.role.slug}`;

      if (params.userid) {
        requestUrl = requestUrl + `&projectuserid=${params.userid}`;
      }

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      const response = await getData(requestUrl);

      console.log("project list response ------>", response);

      if (response.status) {
        setMessageType("success");
        setProjectList(response.data);

        //get total tasks
        const getSumOfTasks = response.data.reduce((acc, curr) => {
          return acc + curr.taskcount;
        }, 0);

        settotalTaskCount(getSumOfTasks);

        //get total logs
        const getSumOfLogs = response.data.reduce((acc, curr) => {
          return acc + curr.logscount;
        }, 0);

        settotalLogsCount(getSumOfLogs);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setShowSkeleton(false);
      setIsDataReady(true);
    }
  };

  //function for get filtered project list
  const getFilteredProjectList = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_PROJECTS + `?token=${token}`;

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setProjectList(response.data);

        //get total tasks
        const getSumOfTasks = response.data.reduce((acc, curr) => {
          return acc + curr.taskcount;
        }, 0);

        settotalTaskCount(getSumOfTasks);

        //get total logs
        const getSumOfLogs = response.data.reduce((acc, curr) => {
          return acc + curr.logscount;
        }, 0);

        settotalLogsCount(getSumOfLogs);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setShowSkeleton(false);
      setIsDataReady(true);
    }
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedProjectList = [...projectList];

    const rowIndex = updatedProjectList.findIndex(
      (projectData) => projectData._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedProjectList[rowIndex].rank = value;
      setProjectList(updatedProjectList);
    }
  };

  //function for update rank
  const updateRankHandler = async (e) => {
    if (selectedProjectIds.length > 0) {
      try {
        const projectListToBeUpdate = projectList.filter((item) =>
          selectedProjectIds.includes(item._id),
        );

        let projectData = {
          projectlist: projectListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_PROJECT + `?token=${token}`;

        const response = await putData(requestURL, projectData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedProjectIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
          setSelectedProjectIds([]);
          setRowSelection({});
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select project for update");
    }
    setShowAlert(true);
  };

  //function for delete project bulk
  const deleteBulkProjectHandler = async () => {
    if (selectedProjectIds.length > 0) {
      try {
        const projectListToBeDelete = projectList.filter((item) =>
          selectedProjectIds.includes(item._id),
        );

        let projectData = {
          projectlist: projectListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_PROJECT + `?token=${token}`;

        const response = await putData(requestURL, projectData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setProjectList((prevList) =>
              prevList.filter((item) => !selectedProjectIds.includes(item._id)),
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select project for delete");
    }
    setShowAlert(true);
  };

  //function for remove tag from project
  const removeTagFromProject = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_PROJECT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedProjectId(null);
      }, 1000);
    }
  };

  //function for after modal close
  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setProjectList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const onCancelProjectWarning = () => {
    setRowSelection({});
    setSelectedProjectIds([]);
  };

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const initialTableColumns = [
    {
      accessorKey: "title",
      header: t("Title"),
      size: 250,
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedProjectId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromProject([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedProjectId &&
                        selectedProjectId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedProjectIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "rank",
      header: "Rank",
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          row.original.moderator.toString() === userInfo._id.toString() ? (
            <input
              type="text"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "80px" }}
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none ps-3">
              {row.original.rank}
            </p>
          )}
        </div>
      ),
    },
    {
      accessorKey: "owner",
      header: t("Owner"),
      size: 200,
      Cell: ({ row }) => (
        <div className="d-flex border-bottom-0">
          <div className="d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{ width: "25px", height: "25px" }}
            >
              <img
                src={
                  row.original.ownerimage == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.ownerimage
                }
                alt="admin"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <p>{row.original.owner}</p>
          </div>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.moderator,
                "MOD_PROJECT",
                row.original._id,
                row.original.title,
              );
            }}
            className={
              row.original.moderator?.toString() === userInfo._id.toString()
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    {
      accessorKey: "projectstartdate",
      header: t("Start Date"),
    },
    {
      accessorKey: "projectenddate",
      header: t("End Date"),
    },
    {
      accessorKey: "companyname",
      header: t("Company"),
    },
    {
      accessorKey: "membercount",
      header: t("Members"),
    },
    {
      accessorKey: "sectioncount",
      header: t("Sections"),
    },
    {
      accessorKey: "taskcount",
      header: t("Tasks"),
    },
    {
      accessorKey: "loghours",
      header: t("Log Hours"),
    },
    {
      accessorKey: "totalcost",
      header: t("Cost"),
    },
  ];

  const columns = useMemo(
    () => initialTableColumns,
    [projectList, selectedTagId, i18n.language],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  const initialColumnOrder = [
    "mrt-row-actions",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  //function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedProjectIds([]);

    setGlobalSearch("");
    setDebouncedSearch("");

    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery?.length > 0) {
      getFilteredProjectList(debouncedSearch, true);
    } else {
      getProjectList(debouncedSearch, true);
    }
  }, [jsonFilterQuery]);

  // ✅ CHANGED: Search effect — no skeleton (table stays visible).
  // isDataReady guard prevents running before initial load finishes.
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load

    if (jsonFilterQuery?.length > 0) {
      getFilteredProjectList(debouncedSearch, false); // withSkeleton=false
    } else {
      getProjectList(debouncedSearch, false); // withSkeleton=false
    }
  }, [debouncedSearch]);

  // ✅ reload happened — always show skeleton
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getProjectList("", true); // withSkeleton=true
      setReloadData(false);
    }
  }, [reloadData]);

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  // save last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedProjectIds(selectedIdsArray);
    } else {
      setSelectedProjectIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // ✅ Debounce — after typing 500ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 500);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_PROJECT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <ProjectManagementCommonHeader componentName="projectlist" />

          <div className="container-fluid px-lg-5">
            {/* -------- header area ---------- */}
            <ProjectListHeader
              userInfo={userInfo}
              moduleAccess={moduleAccess}
              reloadList={refreshRecords}
              changeStatusHandler={deleteBulkProjectHandler}
              updateRankHandler={updateRankHandler}
              projectList={projectList}
              followingProjectCount={followingProjectCount}
              totalTaskCount={totalTaskCount}
              totalLogsCount={totalLogsCount}
              jsonFilterQuery={jsonFilterQuery ? jsonFilterQuery : []}
              selectedProjectIds={selectedProjectIds}
              setShowDeleteOffcanvas={setShowDeleteOffcanvas}
            />

            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={projectList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection}
                  state={{
                    // ✅ If globalSearch exists, use value; otherwise undefined
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  autoResetPageIndex={false}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem key="view">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/details/${row.id}`}
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="copy">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/copyproject/${row.id}`}
                      >
                        {t("Copy Project")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="taxonomy">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/taxonomies/${row.id}`}
                      >
                        {t("View Taxonomies")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="member">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/members/${row.id}`}
                      >
                        {t("View Members")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="task">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/tasksection/${row.id}`}
                      >
                        {t("View Task")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="log">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/logs/${row.id}`}
                      >
                        {t("View Logs")}
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                  // ✅ MRT will not filter, API will filter
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
          </div>
        </section>

        {/* ========= popups and modals area ======== */}
        {/* -------- add label modal ---------- */}
        <AddLabelModal
          moduleName="project"
          selectedIds={selectedProjectIds}
          afterTagModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          moduleSlug="MOD_PROJECT"
        />

        <DeleteProjectWarningModal
          onDelete={deleteBulkProjectHandler}
          onCancelDelete={onCancelProjectWarning}
        />

        <ProjectDisablePopup
          selectedProjectIds={selectedProjectIds}
          showDeleteOffcanvas={showDeleteOffcanvas}
          onPopupClose={() => {
            setShowDeleteOffcanvas(false);
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          setShowAlert={setShowAlert}
          reloadProjectList={() => {
            setProjectList((prevList) =>
              prevList.filter((item) => !selectedProjectIds.includes(item._id)),
            );
          }}
        />

        {/* ---------- filter popup ---------- */}
        <ProjectListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadProjectList={resetFilterData}
          moduleSlug="projectlist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        <AddFollowerModal
          moduleName="projectlist"
          selectedIds={selectedProjectIds}
          afterModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ---------- add company modal ------------ */}
        <AddCompanyModal
          moduleName="project"
          selectedIds={selectedProjectIds}
          afterModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default ProjectListBody;
